import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import some from 'lodash/some';
import every from 'lodash/every';

class AuthorizedComponent extends React.Component {
    render() {
        const { session, requiredRoles, and } = this.props;
        const roles = session.user ? session.user.functions : [];
        let isAuthorized = false;

        if (and) {
            isAuthorized = every(requiredRoles, r => roles.indexOf(r) > -1);
        } else {
            isAuthorized = some(requiredRoles, r => roles.indexOf(r) > -1);
        }

        // console.log(`[AuthorizedComponent] Required roles are ${requiredRoles} ${and ? '(AND)' : ''}`);
        // console.log(`[AuthorizedComponent] User ${isAuthorized ? 'IS' : 'IS NOT'} authorized.`)

        return isAuthorized ? this.props.children : null;
    }
}

AuthorizedComponent.propTypes = {
    requiredRoles: PropTypes.array.isRequired,
    // This indicates that ALL given required roles must be found in the user's roles if true, else it's an OR operation.
    and: PropTypes.bool,
};

AuthorizedComponent.defaultProps = {
    and: false,
};

export default connect(
    state => ({
        session: state.session,
    }),
    null
)(AuthorizedComponent);
